export default __webpack_public_path__ + "static/media/layer4.9539bf8c.webp";